import { useParams } from "react-router";

const useParamsOrThrow = <T extends string>() => {
	const params = useParams();

	for (const [key, value] of Object.entries(params)) {
		if (value === undefined) {
			throw new Error(`Parâmetro de rota obrigatório ausente: "${key}"`);
		}
	}

	return params as Record<T, string>;
};

export { useParamsOrThrow };
